import initializeSwiper from './swiper-utils.js';
import { initLookBook24 } from './components/lookbook.js';
import { swiperCampaign24 } from './components/campaign.js';
import runCartDrawerUpsell from './components/cartUpsell.js';
import { updateNumberCartCount } from './components/navbar.js';
import { productVariantSwatchesPrices } from './components/plp';
import { initSitelock } from './components/sitelock';

// cart drawer upsell
runCartDrawerUpsell();

// swipers
initializeSwiper();
swiperCampaign24();
var handleSelectColor = function handleSelectColor(e) {
  var selectedColor = e.target.dataset.color;
  var product = e.target.dataset.product;
  showColorImages(product, selectedColor);
  showSizesFromSelectedColor(product, selectedColor);
  if (e.target.hasAttribute('data-direct-atc')) {
    var variant = e.target.dataset.variant;
    var availability = e.target.dataset.variantAvailability;
    changeATCVariantId(variant, availability, product);
  }
  ;
  if (e.target.hasAttribute('data-gift-card')) {
    productVariantSwatchesPrices(e.target);
  }
};
var showColorImages = function showColorImages(product, color) {
  var _fieldsetContainer$qu;
  var mediaContainer = document.getElementById("media-container-" + product);
  var mediaColorContainer = mediaContainer.querySelector("#image-container-" + color);
  var fieldsetContainer = document.querySelector("#fieldset-" + product);
  (_fieldsetContainer$qu = fieldsetContainer.querySelector(".variant-color-img.active")) === null || _fieldsetContainer$qu === void 0 || _fieldsetContainer$qu.classList.remove("active");
  mediaContainer.querySelectorAll(".image-container").forEach(function (el) {
    return el.style.display = "none";
  });
  mediaColorContainer.querySelectorAll("img").forEach(function (imagen) {
    imagen.removeAttribute("style");
  });
  mediaColorContainer.style.display = "block";
};
var showSizesFromSelectedColor = function showSizesFromSelectedColor(product, selectedColor) {
  var sizes = document.querySelectorAll("[data-product-id='".concat(product, "']"));
  for (var i = 0; i < sizes.length; i++) {
    var currentVariant = sizes[i];
    if (currentVariant.attributes['data-color'].value == selectedColor) {
      currentVariant.style.display = 'block';
    } else {
      currentVariant.style.display = 'none';
    }
  }
};
var changeATCVariantId = function changeATCVariantId(variant, availability, product) {
  var atcButton = document.querySelector("a[data-product='".concat(product, "']"));
  atcButton.href = "/cart/add?id=".concat(variant, "&quantity=1");
  atcButton.setAttribute('data-variant-id', variant);
  if (availability == 'false') {
    atcButton.setAttribute('disabled', true);
  } else {
    atcButton.removeAttribute('disabled');
  }
  ;
};

// swiper page lookbook 2024

document.addEventListener("DOMContentLoaded", function () {
  var colorInputs = document.querySelectorAll(".variant-color-input");
  colorInputs.forEach(function (input) {
    input.addEventListener("change", handleSelectColor);
  });
  document.body.addEventListener("click", function (evt) {
    console.log("TARGET", evt.target);
    if (evt.target.classList.contains("direct-atc-plp")) {
      return;
    }
    if (evt.target.classList.contains("trigger-atc-plp")) {
      // Seleccionar elementos con clase "active-atc-plp"
      document.querySelectorAll(".active-atc-plp").forEach(function (element) {
        if (evt.target.closest(".item-product") !== element) {
          element.classList.remove("active-atc-plp");
        }
      });

      // Seleccionar elementos con clase "trigger-atc-plp hidden"
      document.querySelectorAll(".item-product:not(.active-atc-plp) .trigger-atc-plp").forEach(function (element) {
        element.textContent = "ADD TO CART";
      });
      evt.target.closest(".item-product").classList.toggle("active-atc-plp");
      evt.target.textContent = "Select a Size";
    } else if (!evt.target.classList.contains("trigger-atc-plp") && !evt.target.classList.contains("add-to-cart-plp") && document.querySelector(".active-atc-plp")) {
      // Seleccionar elementos con clase "active-atc-plp"
      document.querySelectorAll(".active-atc-plp").forEach(function (element) {
        element.classList.remove("active-atc-plp");
      });

      // Seleccionar elementos con clase "trigger-atc-plp hidden"
      document.querySelectorAll(".trigger-atc-plp").forEach(function (element) {
        element.textContent = "ADD TO CART";
      });

      // Seleccionar elementos con clase "add-to-cart-plp active"
      document.querySelectorAll(".add-to-cart-plp.active").forEach(function (element) {
        element.classList.remove("active");
      });
    } else if (evt.target.classList.contains("add-to-cart-plp")) {
      evt.target.classList.add("active");
    }
  });

  /* MODAL INFO - MODEL PDP */

  var modalModelPdp = function modalModelPdp() {
    var modalSign = document.querySelector(".style-with-signs");
    var modalSigns = document.querySelectorAll(".style-with-signs .item__sign");
    if (modalSign) {
      modalSigns.forEach(function (item) {
        item.addEventListener("click", function (e) {
          var currentElement = e.target;
          currentElement.classList.add('active');
          showProductCard(currentElement, true);
        });
      });
    }
  };
  var showProductCard = function showProductCard(currentElement, show) {
    var card = currentElement.closest('.item').querySelector('.card');
    var image_card = currentElement.closest('.images').querySelector('.product-image-pdp').closest('a');
    if (show) {
      card.classList.remove('hidden');
      card.focus();
      document.querySelector('.style-with-signs .overlay').classList.remove('hidden');
    }
    card.addEventListener('blur', function (e) {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        card.classList.add('hidden');
        currentElement.classList.remove('active');
        document.querySelector('.style-with-signs .overlay').classList.add('hidden');
      } else {
        card.focus();
      }
    });
  };
  modalModelPdp();

  // sitelock
  initSitelock(document.querySelector('.js-header-sitelock'));

  // page lookbook 2024
  initLookBook24();

  // countCart
  var idCartCount = document.getElementById('cart-item-count');
  if (idCartCount) {
    window.onclick = function (_ref) {
      var target = _ref.target;
      var ATCButtonsQuery = '#add-to-cart-plp, #pdpn-item-submit, .quantity-button-reduce, .quantity-button-add, .atc-upsell-product, .direct-atc-plp';
      var addToCartLinks = document.querySelectorAll(ATCButtonsQuery);
      addToCartLinks.forEach(function (addToCartLink) {
        if (target.contains(addToCartLink)) {
          setTimeout(function () {
            updateNumberCartCount(idCartCount);
          }, 500);
        }
      });
    };
    setTimeout(function () {
      updateNumberCartCount(idCartCount);
    }, 500);
  }
});
window.handleSelectColor = handleSelectColor;